module.exports = __webpack_public_path__ + "img/create.1461cdb3.svg";